<template>
    <div class="recStandard-page" :style="{ 'max-height': noHead === 'true' ? '100%' : 'calc(100% - 0.98rem)' }">
        <section class="search-out-box">
            <div class="search-section">
                <div class="header">
                    <div v-for="item in areaMap" :key="item.code" :class="['item', { active: curArea.code === item.code }]" @click="changeArea(item)">
                        {{ item.name }}
                    </div>
                </div>
                <div ref="searchArea" class="main">
                    <div class="search-bar">
                        <div class="input-wrap">
                            <input
                                v-model="searchKey"
                                type="text"
                                class="search-input"
                                placeholder="请输入物品"
                                maxlength="20"
                                @compositionstart="typingCtrl(true)"
                                @compositionend="typingCtrl(false)"
                                @input="inputKey($event)"
                                @focus="onFocus"
                            />
                            <div v-show="searchKey" class="close" @click="clearKey()"></div>
                        </div>
                        <span v-show="recType.type !== recTypeMap.limitRec" class="search-btn" @click="query()">查询</span>
                        <div v-if="searchList.length > 0" class="search-list">
                            <div v-for="item in searchList" :key="item.cons_name + item.index" class="item" @click="selectKey(item)">
                                <div class="name" v-html="item.nameStr"></div>
                                <div class="des">{{ item.categoryStr }}</div>
                            </div>
                        </div>
                    </div>
                    <div v-show="recType.show" class="result">
                        <!-- 允许收寄 -->
                        <div v-show="recType.type === recTypeMap.canRec" class="can-rec">
                            <div class="title">该物品可收寄</div>
                            <div class="des" @click="goPrice()">运费时效查询</div>
                            <div v-if="noShip === 'true'" class="send-btn" @click="toShip()">立即寄件</div>
                        </div>
                        <!-- 禁止收寄 -->
                        <div v-show="recType.type === recTypeMap.forbidRec" class="forbid-rec">
                            <div class="title">根据相关法规或我司有关限制条款，该物品禁止收寄</div>
                            <div class="des">
                                <span>有疑问请联系</span>
                                <span class="service" @click="onlineConsult()">在线客服</span>
                            </div>
                        </div>
                        <!-- 限制收寄 -->
                        <div v-show="recType.type === recTypeMap.limitRec" class="limit-rec">
                            <div class="title">为了获取准确的收寄标准，请您补充以下信息</div>
                            <div class="address">
                                <span class="addr-item" @click="selectAddress('origin')">{{ showOriginAddr || '选择寄出地' }}</span>
                                <span class="connect"></span>
                                <span class="addr-item" @click="selectAddress('dest')">{{ showDestAddr || '选择目的地' }}</span>
                            </div>
                            <div :class="['search', { active: btnActive }]" @click="query()">查询</div>
                        </div>
                    </div>
                    <!-- 身份认证 -->
                    <div v-show="showId" class="id-info">
                        <div class="wrap-item">
                            <div class="label">寄件人身份</div>
                            <div class="items">
                                <div class="item" @click="chooseIdType('senderId', '01')">
                                    <img v-if="senderId === '01'" src="@/assets/images/recStandard/checked.png" alt="勾选图标" />
                                    <img v-else src="@/assets/images/recStandard/unchecked.png" alt="勾选图标" />
                                    <span>个人</span>
                                </div>
                                <div class="item" @click="chooseIdType('senderId', '02')">
                                    <img v-if="senderId === '02'" src="@/assets/images/recStandard/checked.png" alt="勾选图标" />
                                    <img v-else src="@/assets/images/recStandard/unchecked.png" alt="勾选图标" />
                                    <span>公司</span>
                                </div>
                            </div>
                        </div>
                        <div class="wrap-item">
                            <div class="label">收件人身份</div>
                            <div class="items">
                                <div class="item" @click="chooseIdType('recId', '01')">
                                    <img v-if="recId === '01'" src="@/assets/images/recStandard/checked.png" alt="勾选图标" />
                                    <img v-else src="@/assets/images/recStandard/unchecked.png" alt="勾选图标" />
                                    <span>个人</span>
                                </div>
                                <div class="item" @click="chooseIdType('recId', '02')">
                                    <img v-if="recId === '02'" src="@/assets/images/recStandard/checked.png" alt="勾选图标" />
                                    <img v-else src="@/assets/images/recStandard/unchecked.png" alt="勾选图标" />
                                    <span>公司</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="search-items">
                        <div class="title">热门查询</div>
                        <div class="item-wrap">
                            <div v-for="(item, index) in curHotItems" :key="index" class="item" @click="fillSearch(item)">
                                <div>{{ item }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="limit-bar">
            <span class="limit-title" @click="showLimitCtrl(true)"
                >进出口件限制寄递物品
                <span class="icon"></span>
            </span>
        </section>
        <section v-show="historyKeys.length" class="history">
            <div class="search-items">
                <div class="title">历史查询<span class="clear" @click="clearHistory()">清空记录</span></div>
                <div class="item-wrap">
                    <div v-for="(item, index) in historyKeys" :key="index" class="item" @click="fillSearch(item)">
                        <div>{{ item }}</div>
                    </div>
                </div>
            </div>
        </section>
        <limit-des :show="showLimitDes" @close="onCloseLimitDes"></limit-des>
        <area-selector
            :isShow="showAreaSelector"
            :tabCode="tabCode.select"
            :title="areaSelectorTitle"
            :areaTypeList="areaTypeList"
            :area="area"
            @closeAreaSelector="closeAreaSelector"
            @confirm="confirm"
        ></area-selector>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
import ajax from '../../api/ajax'
import areaSelector from '@/components/areaSelector/index'
import _ from 'lodash'
import { hotItemsMap, areaMap, areaTypeMap, recTypeMap } from './config'
import getOnlineService from '@/mixins/onlineService/index'
import limitDes from './components/limit-des'
import UIP from '@/util/uip.js'
import { jump } from '@/mixins/pageJump/'
import loginType from '@/constant/loginType'
import { urls } from '@/constant/paths'
import { LOCATION_CODE_MAP } from '@uip-alpha/business-constants'

export default {
    name: 'RecStandard',
    components: {
        limitDes,
        'area-selector': areaSelector
    },
    beforeRouteEnter(to, from, next) {
        // const urlConfig = {
        //     owfUrl: '/mobile/cn/sc/login',
        //     cxUrl: `${urls.MP_CHECK_TICKET}?type=${loginType.WX_ACCEPT}&version=1.0`
        // }
        // jump(urlConfig)
        next()
    },
    props: {
        // 是否隐藏头部
        noHead: {
            type: String,
            default: 'false'
        },
        // 是否隐藏寄件
        noShip: {
            type: String,
            default: 'false'
        },
        // 是否隐藏底部
        noFooter: {
            type: String,
            default: 'false'
        }
    },
    data() {
        return {
            areaMap,
            areaTypeMap,
            recTypeMap,
            curHotItems: [], // 热门物品标签
            curArea: {}, // 当前区域类型
            recType: {
                // 收寄限制类型
                type: '',
                show: false
            },
            showLimitDes: false,
            searchKey: '', // 搜索关键字
            historyKeys: [], // 历史标签
            isInput: false, // 是否在输入中
            searchList: [], // 物品联想列表
            curGoods: null, // 当前选择的联想物品
            originAddr: [], // 始发地
            destAddr: [], // 目的地
            addrType: '', // 选择地址类型
            areaSelectorTitle: '', // 地址选择器标题
            showAreaSelector: false, // 控制地址选择器显示
            areaTypeList: [areaTypeMap.cn], // 需要地址选择器提供的地址选择种类
            area: [],
            tabCode: {
                origin: '',
                dest: '',
                select: ''
            },
            smallPro: false,
            senderId: '',
            recId: ''
        }
    },
    computed: {
        showOriginAddr() {
            return this.originAddr.map(item => item.name).join('-')
        },
        showDestAddr() {
            return this.destAddr.map(item => item.name).join('-')
        },
        showId() {
            const from = this.originAddr && this.originAddr[0] && this.originAddr[0].rateCode
            const to = this.destAddr && this.destAddr[0] && this.destAddr[0].rateCode
            return from && to && this.curArea.code === areaTypeMap.hmt && this.isOutFlow(from, to)
        },
        btnActive() {
            if (!this.showId) {
                return this.showOriginAddr && this.showDestAddr && this.searchKey
            }
            return this.showOriginAddr && this.showDestAddr && this.searchKey && this.senderId && this.recId
        }
    },
    created() {
        this.setTitle('收寄标准查询')
        this.setShowHeader(!(this.noHead === 'true'))
        this.setShowFooter(!(this.noFooter === 'true'))
        this.curArea = this.areaMap[0]
        this.curHotItems = hotItemsMap[this.curArea.code]
        this.getHistory()
        this.resetRecType()
        document.addEventListener('click', this.closeComponent)
        // eslint-disable-next-line no-undef
        wx.miniProgram.getEnv(res => {
            this.smallPro = !!res.miniprogram
        })
        this.getSessionData()
    },
    destroyed() {
        document.removeEventListener('click', this.closeComponent)
    },
    methods: {
        getSessionData() {
            let lastData = sessionStorage.getItem('lastData')
            if (lastData) {
                lastData = JSON.parse(lastData)
                this.changeArea(lastData.curArea)
                this.$nextTick(() => {
                    this.originAddr = lastData.originAddr
                    this.destAddr = lastData.destAddr
                    this.searchKey = lastData.searchKey
                    this.senderId = lastData.senderId
                    this.recId = lastData.recId
                    this.tabCode = lastData.tabCode
                    this.$nextTick(() => {
                        this.recType = lastData.recType
                        sessionStorage.removeItem('lastData')
                    })
                })
            }
        },
        closeAreaSelector() {
            this.showAreaSelector = false
        },
        confirm(selectData) {
            this.showAreaSelector = false
            if (this.addrType === 'origin') {
                this.originAddr = selectData.selectArea
                this.area = selectData.selectArea
                this.tabCode.origin = selectData.selectTabCode
            } else if (this.addrType === 'dest') {
                this.destAddr = selectData.selectArea
                this.area = selectData.selectArea
                this.tabCode.dest = selectData.selectTabCode
            }
        },
        ...mapMutations({
            setTitle: 'setTitle',
            setShowHeader: 'setShowHeader',
            setShowFooter: 'setShowFooter'
        }),
        // 改变区域
        changeArea(item) {
            if (item.code === this.curArea.code) {
                return
            }
            // 移动收寄标准查国际流向跳新页面
            if (item.code === this.areaTypeMap.ibu && window._webconfig.acceptIbuUrl) {
                return window.open(window._webconfig.acceptIbuUrl, '_self')
            }
            this.originAddr = []
            this.destAddr = []
            this.areaTypeList = item.areaTypeList
            this.curArea = item
            this.resetRecType()
            this.searchList = []
            this.curHotItems = hotItemsMap[this.curArea.code]
        },
        getHistory() {
            this.historyKeys = localStorage.getItem('owf_recStandard_search_keys') || ''
            this.historyKeys = this.historyKeys ? JSON.parse(this.historyKeys) : []
        },
        // 清空输入
        clearKey() {
            if (!this.searchKey) {
                return
            }
            this.searchKey = ''
            this.searchList = []
            this.curGoods = null
        },
        showLimitCtrl(flag) {
            this.showLimitDes = flag
        },
        onCloseLimitDes() {
            this.showLimitCtrl(false)
        },
        query() {
            if (this.searchKey && !this.curGoods) {
                this.curGoods = {
                    matchName: this.searchKey
                }
            }
            this.searchList = []
            if (!this.searchKey || !this.curGoods) {
                return this.$toast('请输入查询物品')
            }
            if (this.showId && (!this.senderId || !this.recId)) {
                return this.$toast('请补充身份信息')
            }
            // 埋点
            UIP.sensor.track('PickupDeliveryStandardsButtonClick', {
                event_name: '收寄标准查询_按钮点击',
                flow_type: this.curArea.name
            })
            // 埋点
            UIP.sensor.track('ShipmentStandardMainlandSearchClick', {
                event_name: '收寄标准查询_内地互寄_查询托寄物',
                goods_name: this.searchKey,
                is_need_flow: this.recType.type === this.recTypeMap.limitRec // 是否需要流向
            })
            if (this.curArea.code === this.areaTypeMap.cn && this.recType.type === this.recTypeMap.canRec) {
                return this.getList()
            }
            if (this.recType.type === recTypeMap.forbidRec) {
                return
            }
            if (this.recType.type === recTypeMap.limitRec) {
                if (!Object.keys(this.originAddr).length || !Object.keys(this.destAddr).length) {
                    return this.$toast('为了获取准确的收寄标准，请您补充地址信息')
                }
            }
            this.getList()
        },
        getList() {
            let srcCityCode = ''
            let destCityCode = ''
            if (this.curArea.code === this.areaTypeMap.cn && this.recType.type === this.recTypeMap.canRec) {
                srcCityCode = '-1'
                destCityCode = '-1'
            } else {
                srcCityCode =
                    [this.areaTypeMap.cn, this.areaTypeMap.hmt].indexOf(this.tabCode.origin) > -1
                        ? this.originAddr[this.originAddr.length - 1].rateCode
                        : ''
                destCityCode =
                    [this.areaTypeMap.cn, this.areaTypeMap.hmt].indexOf(this.tabCode.dest) > -1
                        ? this.destAddr[this.destAddr.length - 1].rateCode
                        : ''
            }
            // 埋点
            const search_type = [this.areaTypeMap.cn, this.areaTypeMap.hmt].indexOf(this.curArea.code)
            UIP.sensor.track('ShipmentStandardSearchClick', {
                event_name: '收寄标准查询_流向_查询',
                search_type: search_type > -1 ? search_type : 2,
                goods_name: this.searchKey,
                flow: `${srcCityCode}-${destCityCode}`
            })
            this.$loading('加载中')
            const params = {
                srcCountryCode: [this.areaTypeMap.hmt, this.areaTypeMap.ibu].indexOf(this.tabCode.origin) > -1 ? this.originAddr[0].rateCode : 'CN',
                destCountryCode: [this.areaTypeMap.hmt, this.areaTypeMap.ibu].indexOf(this.tabCode.dest) > -1 ? this.destAddr[0].rateCode : 'CN',
                srcCityCode,
                destCityCode,
                isAccurate: 0,
                commodityName: this.searchKey,
                currentPage: 1,
                pageSize: 10
            }
            if (this.showId) {
                Object.assign(params, {
                    consignorRemark: this.senderId,
                    addresseeRemark: this.recId
                })
            }
            const inParams = {
                consignment: {
                    name: params.commodityName
                },
                origin: {
                    countryCode: params.srcCountryCode,
                    cityCode: params.srcCityCode
                },
                dest: {
                    countryCode: params.destCountryCode,
                    cityCode: params.destCityCode
                }
            }
            ajax[this.showId ? 'getAcceptResultOut' : 'getAcceptResultIn'](this.showId ? { params } : { data: inParams })
                .then(res => {
                    const list = res.data.result || []
                    const isHitBlockAllowList = list[0].isHitBlockAllowList || false
                    if (list.length) {
                        if (this.curArea.code === this.areaTypeMap.cn && this.recType.type === this.recTypeMap.canRec) {
                            if (list.length > 1) {
                                // 限制收寄
                                this.recType.type = this.recTypeMap.limitRec
                                this.recType.show = true
                                return
                            }
                            if (isHitBlockAllowList && list[0].acceptCriteriaList[0].finalExpressRequireCode === 'ExpressRequireProhibit') {
                                // 禁止收寄
                                this.recType.type = this.recTypeMap.forbidRec
                                this.recType.show = true
                            } else if (isHitBlockAllowList && list[0].acceptCriteriaList[0].finalExpressRequireCode === 'ExpressRequireAllow') {
                                // 可收寄
                                this.recType.type = this.recTypeMap.canRec
                                this.recType.show = true
                            } else {
                                // 限制收寄
                                this.recType.type = this.recTypeMap.limitRec
                                this.recType.show = true
                            }
                        } else {
                            const search_type = [this.areaTypeMap.cn, this.areaTypeMap.hmt].indexOf(this.curArea.code)
                            sessionStorage.setItem(
                                'lastData',
                                JSON.stringify({
                                    originAddr: this.originAddr,
                                    destAddr: this.destAddr,
                                    searchKey: this.searchKey,
                                    curArea: this.curArea,
                                    senderId: this.senderId,
                                    recId: this.recId,
                                    tabCode: this.tabCode,
                                    recType: this.recType
                                })
                            )
                            this.$router.push({
                                name: 'recStandardRes',
                                params: {
                                    list,
                                    origin: this.showOriginAddr.split('-').join(''),
                                    dest: this.showDestAddr.split('-').join(''),
                                    searchKey: this.searchKey,
                                    search_type: search_type > -1 ? search_type : 2 // 寄件流向
                                }
                            })
                        }
                    } else {
                        if (this.curArea.code === this.areaTypeMap.cn && this.recType.type === this.recTypeMap.canRec) {
                            // 限制收寄
                            this.recType.type = this.recTypeMap.limitRec
                            this.recType.show = true
                        } else {
                            this.$toast('未搜索到相关信息，请以收派员上门核实为准')
                        }
                    }
                })
                .catch(() => {
                    if (this.curArea.code === this.areaTypeMap.cn && this.recType.type === this.recTypeMap.canRec) {
                        // 限制收寄
                        this.recType.type = this.recTypeMap.limitRec
                        this.recType.show = true
                    } else {
                        this.$toast('未搜索到相关信息，请以收派员上门核实为准')
                    }
                })
                .finally(() => {
                    // 针对特定场景判断是否需要流向埋点
                    if (this.curArea.code === this.areaTypeMap.cn) {
                        UIP.sensor.track('ShipmentStandardMainlandSearchClick', {
                            event_name: '收寄标准查询_内地互寄_查询托寄物',
                            goods_name: this.searchKey,
                            is_need_flow: this.recType.type === this.recTypeMap.limitRec // 是否需要流向
                        })
                    }
                    this.$loading()
                    this.saveKey()
                    this.getHistory()
                })
        },
        // 缓存历史
        saveKey() {
            if (!this.searchKey) {
                return
            }
            this.historyKeys.unshift(this.searchKey)
            this.historyKeys = [...new Set(this.historyKeys)]
            localStorage.setItem('owf_recStandard_search_keys', JSON.stringify(this.historyKeys))
        },
        // 回填选项
        fillSearch(item) {
            if (!item) {
                return
            }
            this.searchKey = item
            this.fuzzySearch()
        },
        // 清空历史
        clearHistory() {
            localStorage.setItem('owf_recStandard_search_keys', '')
            this.historyKeys = []
        },
        // 中文输入控制
        typingCtrl(flag) {
            this.isInput = flag
        },
        onFocus() {
            if (this.searchKey) {
                this.fuzzySearch()
            }
        },
        // 输入防抖
        inputKey: _.debounce(function (e) {
            if (this.isInput || !this.searchKey) {
                return
            }
            this.fuzzySearch()
        }, 300),
        // 物品联想
        fuzzySearch() {
            ajax.getCargoAssociated({
                params: {
                    name: this.searchKey
                }
            })
                .then(({ data = {} }) => {
                    this.searchList = data.result || []
                    this.searchList.forEach(item => {
                        item.categoryStr = item.category.join('，')
                        const regexp = new RegExp(`${this.searchKey}`, 'g')
                        item.nameStr = item.cons_name.replace(regexp, `<span style="color:#DC1E32">${this.searchKey}</span>`)
                    })
                })
                .catch(response => {
                    this.searchList = []
                })
        },
        selectKey(item) {
            this.curGoods = item || null
            this.searchKey = this.curGoods.cons_name || ''
            this.searchList = []
        },
        selectAddress(type) {
            this.addrType = type
            this.showAreaSelector = true
            if (type === 'origin') {
                this.areaSelectorTitle = '寄出地选择'
                this.area = this.originAddr
                this.tabCode.select = this.tabCode.origin
            } else if (type === 'dest') {
                this.areaSelectorTitle = '目的地选择'
                this.area = this.destAddr
                this.tabCode.select = this.tabCode.dest
            }
        },
        // 点击其他区域关闭物品联想
        closeComponent(e) {
            const self = this
            const needClose = [
                {
                    ref: 'searchArea'
                }
            ]
            needClose.forEach(item => {
                if (
                    (self.$refs[item.ref] && self.$refs[item.ref].$el && !self.$refs[item.ref].$el.contains(e.target) && self.searchList.length) ||
                    (self.$refs[item.ref] && self.$refs[item.ref].contains && !self.$refs[item.ref].contains(e.target) && self.searchList.length)
                ) {
                    self.searchList = []
                }
            })
        },
        async onlineConsult() {
            const url = await getOnlineService()
            window.open(url, '_blank')
        },
        goPrice() {
            // 埋点
            UIP.sensor.track('ShipmentStandardMainlandLimitClick', {
                event_name: '收寄标准查询_内地互寄_运费时效查询',
                goods_name: this.searchKey
            })
            this.$router.push({
                name: 'price',
                query: {
                    noHead: this.noHead
                }
            })
        },
        resetRecType() {
            this.recType.show = this.curArea.code !== this.areaTypeMap.cn
            this.recType.type = this.curArea.code === this.areaTypeMap.cn ? this.recTypeMap.canRec : this.recTypeMap.limitRec
        },
        toShip() {
            this.setShowHeader(false) // 隐藏公共的头部
            // 埋点
            const search_type = [this.areaTypeMap.cn, this.areaTypeMap.hmt].indexOf(this.curArea.code)
            UIP.sensor.track('ShipmentStandardConsignorClick', {
                event_name: '收寄标准查询_立即寄件',
                search_type: search_type > -1 ? search_type : 2,
                goods_name: this.searchKey
            })
            if (this.smallPro) {
                setTimeout(() => {
                    // eslint-disable-next-line no-undef
                    wx.miniProgram.navigateTo({
                        url: '/pages/order/sending/order-home/order-home?type=normal', // 跳转回小程序的页面,传参id, 小程序onLoad函数接收参数即可
                        success: () => {
                            console.log('success')
                        },
                        fail: () => {
                            console.log('跳转回小程序的页面fail')
                        }
                    })
                }, 0)
            } else {
                const urlConfig = {
                    owfUrl: `/mobile/cn/sc/login?type=${loginType.WX_ORDER}`,
                    cxUrl: `${urls.MP_CHECK_TICKET}?type=${loginType.WX_ORDER}`
                }
                jump(urlConfig)
            }
        },
        chooseIdType(type, idValue) {
            this[type] = idValue
        },
        getReginOrCode(flag = '') {
            if (/^\d.*$/.test(flag)) {
                return (
                    new Map([
                        [LOCATION_CODE_MAP.TW, 'TW'],
                        [LOCATION_CODE_MAP.HK, 'HK'],
                        [LOCATION_CODE_MAP.MAC, 'MO']
                    ]).get(flag) || 'CN'
                )
            } else {
                return (
                    new Map([
                        ['TW', LOCATION_CODE_MAP.TW],
                        ['HK', LOCATION_CODE_MAP.HK],
                        ['MC', LOCATION_CODE_MAP.MAC],
                        ['MO', LOCATION_CODE_MAP.MAC]
                    ]).get(flag.toUpperCase()) || ''
                )
            }
        },
        isOutFlow(sender, receiver) {
            const sendFlow = this.getReginOrCode(sender)
            const receiveFlow = this.getReginOrCode(receiver)
            return sendFlow !== receiveFlow
        }
    },
    watch: {
        searchKey(val, old) {
            this.resetRecType()
            if (!val) {
                this.searchList = []
                this.curGoods = null
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.recStandard-page {
    background: #fff;
    .search-out-box {
        padding-top: 0.2rem;
        .search-section {
            background: #fff;
            margin: 0 0.2rem;
            box-shadow: 0 0.08rem 0.32rem 0 rgba(0, 0, 0, 0.1);
            border-radius: 0.08rem;
            padding-bottom: 0.32rem;
            .header {
                background: #f4f4f4;
                font-size: 0.26rem;
                color: #999;
                letter-spacing: 0;
                display: flex;
                justify-content: space-around;
                .item {
                    position: relative;
                    flex: 1;
                    text-align: center;
                    padding: 0.18rem 0;
                    &.active {
                        background: #fff;
                        color: #222;
                        &:before {
                            content: ' ';
                            width: 0.52rem;
                            height: 0.04rem;
                            background: #dc1e32;
                            position: absolute;
                            bottom: 0;
                            left: 50%;
                            margin-left: -0.26rem;
                            border-radius: 0.02rem;
                        }
                    }
                }
            }
            .main {
                margin-top: 0.32rem;
                padding: 0 0.24rem;
                .search-bar {
                    display: flex;
                    align-items: center;
                    position: relative;
                    .input-wrap {
                        flex: 1;
                        position: relative;
                        .search-input {
                            background-color: #f9f9f9;
                            border-radius: 0.41rem;
                            height: 0.72rem;
                            line-height: 0.72rem;
                            font-size: 0.27rem;
                            color: #222;
                            letter-spacing: 0;
                            border: none;
                            padding: 0;
                            padding-left: 0.68rem;
                            background-image: url('~@/assets/images/recStandard/icon-search.png');
                            background-repeat: no-repeat;
                            background-position: 0.24rem center;
                            background-size: 0.31rem;
                            padding-right: 0.8rem;
                        }
                        .close {
                            width: 0.5rem;
                            height: 0.5rem;
                            background-image: url('~@/assets/images/recStandard/icon-close.png');
                            background-repeat: no-repeat;
                            background-position: center;
                            background-size: 0.28rem;
                            position: absolute;
                            right: 0.24rem;
                            top: 50%;
                            margin-top: -0.25rem;
                        }
                    }
                    .search-list {
                        position: absolute;
                        width: calc(100% + 0.48rem);
                        background: #fff;
                        top: 0.72rem;
                        left: -0.24rem;
                        padding: 0 0.24rem;
                        border-radius: 0.08rem;
                        max-height: 7.5rem;
                        overflow-y: auto;
                        overflow-x: hidden;
                        z-index: 2;
                        box-shadow: -0.04rem 0.08rem 0.2rem 0 rgba(0, 0, 0, 0.05), 0.04rem 0.08rem 0.2rem 0 rgba(0, 0, 0, 0.05);
                        .item {
                            display: flex;
                            justify-content: space-between;
                            height: 0.94rem;
                            line-height: 0.94rem;
                            border-bottom: solid 1px #f1f1f1;
                            &:last-child {
                                border: none;
                            }
                            div {
                                flex: 1;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                                word-break: break-all;
                            }
                            .name {
                                font-size: 0.28rem;
                                color: #333333;
                            }
                            .des {
                                font-size: 0.24rem;
                                color: #666666;
                                text-align: right;
                            }
                        }
                    }
                }
                .search-btn {
                    display: inline-block;
                    width: 0.8rem;
                    font-size: 0.26rem;
                    color: #222222;
                    letter-spacing: 0;
                    text-align: center;
                    margin-left: 0.2rem;
                }
                .result {
                    background: #fffcee;
                    border-radius: 0.08rem;
                    margin-top: 0.32rem;
                    position: relative;
                    .can-rec {
                        padding: 0.55rem;
                        .title {
                            font-size: 0.32rem;
                            color: #333333;
                        }
                        .des {
                            font-size: 0.24rem;
                            color: #007cf0;
                            margin-top: 0.1rem;
                        }
                        .send-btn {
                            width: 1.84rem;
                            height: 0.62rem;
                            line-height: 0.62rem;
                            background: #cc3244;
                            font-size: 0.26rem;
                            color: #ffffff;
                            text-align: center;
                            border-radius: 0.8rem;
                            position: absolute;
                            top: 50%;
                            margin-top: -0.32rem;
                            right: 0.55rem;
                        }
                    }
                    .forbid-rec {
                        padding: 0.58rem 0;
                        text-align: center;
                        .title {
                            font-size: 0.26rem;
                            color: #cc3244;
                        }
                        .des {
                            margin-top: 0.16rem;
                            font-size: 0.24rem;
                            color: #666666;
                            letter-spacing: 0;
                            text-align: center;
                            .service {
                                margin-left: 0.1rem;
                                font-size: 0.24rem;
                                color: #222222;
                                letter-spacing: 0;
                                text-align: center;
                                background-image: url('~@/assets/images/recStandard/icon-contact.png');
                                background-repeat: no-repeat;
                                background-position: left center;
                                background-size: 0.32rem;
                                padding-left: 0.34rem;
                            }
                        }
                    }
                    .limit-rec {
                        padding: 0.32rem 0.3rem;
                        padding-right: 2.35rem;
                        .title {
                            font-size: 0.26rem;
                            color: #f99100;
                        }
                        .address {
                            margin-top: 0.16rem;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            .addr-item {
                                font-size: 0.26rem;
                                color: #8b847a;
                                padding-bottom: 0.09rem;
                                border-bottom: solid 1px #c7c2ae;
                                flex: 1;
                                width: 0;
                                align-self: stretch;
                            }
                            .connect {
                                width: 0.26rem;
                                height: 0.02rem;
                                border-radius: 0.02rem;
                                display: inline-block;
                                background: #222;
                                margin-bottom: 0.12rem;
                                margin: 0 0.1rem;
                            }
                        }
                        .search {
                            width: 1.7rem;
                            height: 0.62rem;
                            line-height: 0.62rem;
                            background: #cccccc;
                            font-size: 0.26rem;
                            color: #ffffff;
                            text-align: center;
                            border-radius: 0.8rem;
                            position: absolute;
                            top: 50%;
                            margin-top: -0.32rem;
                            right: 0.3rem;
                            &.active {
                                background: #cc3244;
                            }
                        }
                    }
                }
            }
        }
    }
    .search-items {
        margin-top: 0.4rem;
        .title {
            font-size: 0.26rem;
            color: #333333;
            margin-bottom: 0.22rem;
            .clear {
                font-size: 0.24rem;
                color: #666666;
                text-align: right;
                line-height: 0.31rem;
                float: right;
            }
        }
        .item-wrap {
            margin-bottom: -0.14rem;
            .item {
                background: #f9f9f9;
                border-radius: 0.26rem;
                padding: 0.1rem 0.24rem;
                font-size: 0.24rem;
                color: #333333;
                letter-spacing: 0;
                text-align: left;
                display: inline-block;
                margin-right: 0.14rem;
                margin-bottom: 0.14rem;
                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
    .limit-bar {
        margin-top: 0.32rem;
        text-align: center;
        .limit-title {
            display: inline-block;
            font-size: 0.24rem;
            color: #666666;
            text-align: center;
            line-height: 0.31rem;
            height: 0.31rem;
            padding-right: 0.31rem;
            .icon {
                width: 0.31rem;
                height: 0.31rem;
                display: inline-block;
                vertical-align: bottom;
                background-image: url('~@/assets/images/recStandard/icon-info.png');
                background-repeat: no-repeat;
                background-position: center;
                background-size: 0.31rem;
            }
        }
    }
    .history {
        margin-top: 0.4rem;
        padding: 0 0.44rem;
        margin-bottom: 0.2rem;
        .search-items {
            .item-wrap {
                max-height: 1.3rem;
                overflow: hidden;
                .item {
                    background: #f9f9f9;
                }
            }
        }
    }
    .id-info {
        background: #fff;
        border-radius: 0.1rem;
        margin-top: 0.32rem;
        padding: 0 0.2rem;
        box-shadow: 0 0.08rem 0.32rem 0 rgba(0, 0, 0, 0.1);
        font-size: 0.28rem;
        .wrap-item {
            display: flex;
            justify-content: space-between;
            height: 1rem;
            align-items: center;
            border-bottom: solid 1px #f2f2f2;
            .label {
                color: black;
                &::after {
                    content: '*';
                    color: #dc1e32;
                }
            }
            .items {
                display: flex;
                align-items: center;
                .item {
                    margin-left: 0.3rem;
                    img {
                        width: 0.4rem;
                        margin-right: 0.01rem;
                        vertical-align: top;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/recStandard/index.vue